import { Component, Injectable, Inject, LOCALE_ID } from '@angular/core';
import { NgbAlertModule, NgbDatepickerI18n, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

const I18N_VALUES = {
	'ro-RO': {
		weekdays: ['Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ', 'Du'],
		months: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
		weekLabel: 'săp',
	},
	'en-US': {
		weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
		months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		weekLabel: 'wk',
	},
	'fr-FR': {
		weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
		months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
		weekLabel: 'sem',
	},
	// Fallback for any other locale - defaults to Romanian
	'ro': {
		weekdays: ['Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ', 'Du'],
		months: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
		weekLabel: 'săp',
	}
};

// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also
// use the Angular LOCALE_ID value
@Injectable()
export class I18n {
	constructor(@Inject(LOCALE_ID) private localeId: string) {}
	
	get language(): string {
		// Return the current locale from Angular's LOCALE_ID
		return this.localeId;
	}
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class NgbCustomDatepickerI18n extends NgbDatepickerI18n {
	constructor(private _i18n: I18n) {
		super();
	}

	private getLocaleData() {
		const locale = this._i18n.language;
		// Try exact match first, then fallback to base language, then default to Romanian
		return I18N_VALUES[locale] || I18N_VALUES[locale.split('-')[0]] || I18N_VALUES['ro'];
	}

	getWeekdayLabel(weekday: number): string {
		return this.getLocaleData().weekdays[weekday - 1];
	}
	
	getWeekLabel(): string {
		return this.getLocaleData().weekLabel;
	}
    //
    getWeekdayShortName(weekday: number): string {
        return this.getWeekdayLabel(weekday);
    }
	
	getMonthShortName(month: number): string {
		return this.getLocaleData().months[month - 1];
	}
	
	getMonthFullName(month: number): string {
		return this.getMonthShortName(month);
	}
	
	getDayAriaLabel(date: NgbDateStruct): string {
		return `${date.day}-${date.month}-${date.year}`;
	}
}


